import React from "react"

export default () => (
  <svg width="18" height="18" viewBox="0 0 18 18">
    <path d="M9,1 C13.418278,1 17,4.581722 17,9 C17,13.418278 13.418278,17 9,17 C4.581722,17 1,13.418278 1,9 C1,4.581722 4.581722,1 9,1 Z M13,8 L5,8 L5,10 L13,10 L13,8 Z" />
  </svg>
)
